module.exports = __webpack_public_path__ + "static/media/41-9.4108bc82.mp3";